import Alpine from "alpinejs";

Alpine.data('GlossaryReference', (definitions) => ({
    glossaryTouched: false,
    definitions: null,
    activeTerm: null,
    menuHeight: 0,
    entryEl: null,
    init(){
        const body = document.querySelector('main');
        this.references = body.querySelectorAll('[data-glossary-reference]');
        this.definitions = definitions;

        this.bindEvents();
        this.calcHeight();
    },

    bindEvents(){
        this.references.forEach((ref) => {
            ref.addEventListener('click', (e) => {
                e.preventDefault();
                this.glossaryTouched = true;
                this.$store.ui.glossaryReferenceActive = true;
                this.entryEl = e.target;
                
                this.selectTerm(e.target.getAttribute('data-glossary-reference'));
                
                setTimeout(() => {
                    this.$refs.closeGlossary.focus()
                }, 150)
            });
        })
    },
    selectTerm(slug) {
        this.activeTerm = this.definitions.find((def) => {
            return def.slug === slug;
        });
    },
    calcHeight(){
        this.menuHeight = window.innerHeight - this.$el.getBoundingClientRect().top; 
    },
    closeGlossary() {
        this.$store.ui.glossaryReferenceActive = false;
        this.entryEl.focus();   
    }
}));